import React, { useState } from "react";
import CalculatorPage from "./CalculatorPage";
import PrintingCalculatorPage from "./PrintingCalculatorPage";
import UVPrintingCalculatorPage from "./UVPrintingCalculatorPage";
import S from "../styles";

const TABS = [
  { key: "Laser Cutting", label: "Laser Cutting" },
  { key: "3D Printing", label: "3D Printing" },
  { key: "UV Printing", label: "UV Printing" },
  { key: "CNC", label: "CNC" },
];

export default function JobCostPage({ materials, filament, employees, editingJob, onSaveJob, onUpdateJob, onClearEdit }) {
  const [tab, setTab] = useState(editingJob?.jobType || "Laser Cutting");

  const activeTab = editingJob?.jobType || tab;

  return (
    <div>
      <main style={S.main}>
        <div style={{ marginBottom: 4 }}>
          <h2 style={{ fontFamily: "'Archivo Black', 'Archivo', sans-serif", fontSize: 32, fontWeight: 900, color: "#0A0A0F", letterSpacing: "-0.02em", textTransform: "uppercase", lineHeight: 1, marginBottom: 4 }}>Job Cost Calculator</h2>
          <p style={{ fontSize: 14, color: "rgba(10,10,15,0.58)", marginBottom: 16 }}>Calculate costs and pricing for each job type</p>
        </div>
        <div style={{ marginBottom: 24 }}>
          <nav style={S.nav}>
            {TABS.map(({ key, label }) => (
              <button
                key={key}
                onClick={() => setTab(key)}
                style={{ ...S.navBtn, ...(activeTab === key ? S.navBtnActive : {}) }}
              >
                {label}
              </button>
            ))}
          </nav>
        </div>
        {activeTab === "3D Printing" ? (
          <PrintingCalculatorPage
            key={activeTab}
            filament={filament}
            employees={employees}
            editingJob={editingJob}
            onSaveJob={onSaveJob}
            onUpdateJob={onUpdateJob}
            onClearEdit={onClearEdit}
            jobType={activeTab}
          />
        ) : activeTab === "UV Printing" ? (
          <UVPrintingCalculatorPage
            key={activeTab}
            employees={employees}
            editingJob={editingJob}
            onSaveJob={onSaveJob}
            onUpdateJob={onUpdateJob}
            onClearEdit={onClearEdit}
            jobType={activeTab}
          />
        ) : (
          <CalculatorPage
            key={activeTab}
            materials={materials}
            employees={employees}
            editingJob={editingJob}
            onSaveJob={onSaveJob}
            onUpdateJob={onUpdateJob}
            onClearEdit={onClearEdit}
            jobType={activeTab}
          />
        )}
      </main>
    </div>
  );
}
